"use client";
import { useState } from "react";
import React from "react";
import "home/Transitions.css";
import { Navbar } from "home/Navbar";
import { Hero } from "home/Hero";
import { Steps } from "home/Steps";
import dynamic from "next/dynamic";
import { Cta } from "home/Cta";
import { Footer } from "home/Footer";
import { HeroMobile } from "home/HeroMobile";
// import {Templates} from "home/Templates"

// Lazy-load heavy client components to reduce initial hydration/TBT.
// Load only after user interaction or on viewport entry
const Templates = dynamic(
  () => import("home/Templates").then((mod) => mod.Templates),
  {
    ssr: false,
    loading: () => (
      <section className="relative overflow-hidden bg-[#F9F9F9]">
        <div className="text-center font-montserrat tracking-tight text-[#2B282B]">
          <div className="h-28 md:h-32 lg:h-40" />
        </div>
      </section>
    ),
  }
);

const Testimonials = dynamic(() => import("home/Testimonials").then((m) => m.Testimonials), {
  ssr: false,
  loading: () => (
    <section>
      <div className="text-center font-montserrat tracking-tight text-[#2B282B]">
        <div className="h-20" />
      </div>
    </section>
  ),
});

// Score component is below fold, load with lower priority
const Score = dynamic(() => import("home/Score"), {
  ssr: false,
  loading: () => <div className="w-full min-h-[600px] bg-gray-100" />,
});
import { AuthenticationOptions } from "components/AuthenticationOptions";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  useAppSelector,
  useSaveStateToLocalStorageOnChange,
  useSetInitialStore,
} from "lib/redux/hooks";
// import SubscriptionOverlay from "components/Subscription";
import { selectIsAuthenticationOpen } from "lib/redux/uiSlice";
import FAQ from "home/faq";
import { accordianList } from "home/constants";
// import Image from "next/image";

export default function Home() {
  // const renderCount = React.useRef(0);
  // renderCount.current++;
  // console.log('HOME PAGE MOUNT/RENDER #' + renderCount.current, {
  //   timestamp: new Date().toISOString(),
  //   location: 'page.tsx',
  //   renderCount: renderCount.current
  // });
  // console.trace('HOME RENDER STACK TRACE');
  useSetInitialStore();
  useSaveStateToLocalStorageOnChange();
  const isAuthenticationOpen = useAppSelector(selectIsAuthenticationOpen);
  return (
    <main className="overflow-hidden bg-[#F9F9F9]">
      <Navbar />
      <Hero />
      <HeroMobile />
      <div className="hero-breakdown-gradient h-10 md:h-20"></div>
      <Steps />
      <div className="hero-breakdown-gradient1 h-10 md:h-20"></div>
      {/* Below-fold components lazy loaded */}
      <Templates />
      <div className="h-10 md:h-20"></div>
      <Score />
      <div className="h-10 md:h-20"></div>
      <Testimonials />
      <div className="h-10 md:h-20"></div>
      <FAQ accordianList={accordianList} />
      <div className="h-10 md:h-20"></div>
      <Cta />
      <Footer />
      {isAuthenticationOpen && <AuthenticationOptions />}
      {/* <SubscriptionOverlay onClose={() => console.log("hi")} /> */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </main>
  );
}
